<div class="mt-4" style="width: 100%">
  <div class="d-flex">
    <h4>Feedback</h4>
  </div>
  <hr class="pb-1">
  <form [formGroup]="form" (ngSubmit)="save()">
    <div class="form-group">
      <div class="d-flex">
        <div class="pt-3 d-flex flex-column w-100">
          <div class="form-group label">We value your business and suggestions. Please let us know what we can do to improve.</div>
          <textarea placeholder="Comments and suggestions..." class="form-control" formControlName="feedback"></textarea>
        </div>
      </div>
    </div>
    <div class="col-12 text-center text-sm-left">
      <button class="btn btn-primary margin-bottom-none">Submit Feedback</button>
    </div>
  </form>
</div>
  